import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../../tools';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
import '../../css/charge_demo_item.scss';
// import { Link } from 'react-router-dom';
// import API from '../api';
// import { Cookies, withCookies } from 'react-cookie';
// import Enums from '../enums'

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default function ChargeDemoItem(props) {
    const bgColorList = {
        "IT210805175157": [239, 239, 239],
        "IT210809111838": [206, 222, 220],
        "IT210809112018": [253, 210, 84],
        "IT210809112146": [251, 155, 149]
    }

    function render() {
        let { data } = props;
        if (null == data) data = {};
        let bgColor = {};
        // console.log(data.item_id, bgColorList, bgColorList.hasOwnProperty(data.item_id));
        if (data.item_id && bgColorList.hasOwnProperty(data.item_id)) {
            let color = bgColorList[data.item_id];
            bgColor = {
                background: `rgb(${color[0]}, ${color[1]}, ${color[2]})`
            };
        }

        // item_description: "(測試)進階套餐PLUS說明"
        // item_id: "IT210805175157"
        // item_name: "(測試)Premium PLUS"
        // item_type: "後台點數"
        // platform_point: 5000
        // price: 40000
        let promotedDom = (
            <div className="promote">
                <i class="bi bi-hand-thumbs-up"></i>最熱門
            </div>
        )
        return (
            <div className={"chargeItemDemo " + (props.isPromoted ? "promoted" : "")}>
                {props.isPromoted ? promotedDom : null}
                <div className="title"><strong>{data.item_name ? data.item_name : ""}</strong></div>
                <div className="price"><strong><span>{(data.price ? Tools.formatPrice(data.price) : "")}</span><span>{"元"}</span></strong></div>
                {/* <div className="btn"><Button variant="primary" onClick={() => { props.onClick(data.item_id) }}>購買</Button></div> */}
                <div className="desc">{data.item_description ? data.item_description : ""}</div>
                <div className={"discount dis-" + props.classKey}>{props.discount}</div>
            </div>
        );
    }
    return render();
}